import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../shared/config/app-config';
import { User, UserService } from '../../shared';

@Component({
  templateUrl: 'carepathready.component.html',
  styleUrls: ['../style.component.css']
})
export class CarepathreadyComponent implements OnInit {
  public data: Object;
  params: any;
  path: any = {};
  public myobj: any = {};
  public myobj1: any = {};
  public apiurl: any = environment.api_url;
  public onboardImageURL: any = environment.onboardImageURL;
  patpwd: any = {};
  patpwd1: any = {};
  patswfid: any;
  public imageURL: string = environment.cloudeImageURL;
  public currentUser: User;
  modalRef1: BsModalRef;

  constructor(
    private activeroute: ActivatedRoute,
    private routers: Router,
    private modalService: BsModalService,
    private userService: UserService,
  ) { }

  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )

    // if(this.currentUser.item.hostModel=="CLOUD")
    // this.imageURL = environment.cloudeImageURL;
    // else   
    // this.imageURL = environment.vmImageURL;

    /* this.patientservice
    .getname(this.params.patid)
    .subscribe(
      data => {
  
        this.path = data;
      }
    ); */
    if (window.localStorage['pwd']) {
      this.myobj = JSON.parse(window.localStorage['pwd']);

      this.myobj1 = JSON.stringify(this.myobj);
      // ////console.log(this.myobj1)
      // ////console.log(this.myobj.userFnLn)
    }
    else {
      // ////console.log("logout")
      this.routers.navigate([`/login`])
    }
    if (window.localStorage['patpwd']) {
      this.patpwd = JSON.parse(window.localStorage['patpwd']);

      this.patpwd1 = JSON.stringify(this.patpwd);
      // ////console.log(this.patpwd.newpswd)
      // ////console.log(this.patpwd1)
    }

  }

  upload() {
    let credentials = {
      'username': this.myobj.userEmail,
      'password': btoa(this.patpwd.newpswd),
      'captcha': '',
      'mode': '',
      'usermode': localStorage.getItem('userMode') ? atob(localStorage.getItem('userMode')) : 'c',
      'forcelogin': 'true'
    }
    this.userService.attemptAuth(credentials)
      .subscribe(
        data => {
          //////console.log(data);


        }
      );
  }


  startupAndroidCheck(androidCheck: TemplateRef<any>) {
    if (navigator.userAgent.search("Android") != -1) {
      this.modalRef1 = this.modalService.show(androidCheck, {
        class: 'modal-sm',
        backdrop: 'static'
      })
    }
    else {
      this.upload();
    }
  }
}







